import moment from "moment";

export const timestampToDateString = (timestamp) => {
    return moment(timestamp, "X").format("YYYY-MM-DD")
};

export const dateTimeToDateString = (datetime) => {
    return moment.utc(datetime).format("YYYY-MM-DD")
};


// WEBPACK FOOTER //
// ./src/lib/FormFormatters.js